/* Dr.Primal — capture step: the reward.

   Shows the code, stores it on the cart through the shop adapter, and says plainly which
   happened: the "added to your basket" line when the cart took it, the "enter this code at
   checkout" line when it did not. Every line is Liquid's, and this file only un-hides
   one. The code itself is data, `ctx.config.DISCOUNT_CODE`, the one place it is written.

   With no code (DISCOUNT_CODE ''), the step shows the "none" line, which states the
   saving, leaves the code-only elements hidden, and sends nothing to the cart or to
   PostHog's capture_code_applied.

   The engine records `submittedAt` when this last step mounts, so nothing here touches
   storage. `mount()` resolves when the visitor is done with the step, i.e. clicks the
   button to the product page. The click is not prevented, so the link still navigates;
   the engine closes the dialog on the way. Closing the dialog instead ends the flow in
   the engine, and this promise is simply left behind.

   `capture_code_applied` carries `ok` (the cart came back with the code) and, when
   Shopify said, `applicable` (it already applies to the basket as it stands). */
(function () {
  'use strict';

  // Markup hooks. Each must match sections/dp-capture.liquid.
  var CODE_SELECTOR = '[data-dp-capture-code]';
  var CTA_SELECTOR = '[data-dp-capture-cta]';
  var CODE_ONLY_SELECTOR = '[data-dp-capture-code-only]'; // rendered hidden; shown only when there is a code
  var OUTCOME_ATTRIBUTE = 'data-dp-capture-outcome'; // its values, 'applied', 'fallback' and 'none', are what outcomeFor() returns

  var capture = window.dpCapture;
  if (!capture) {
    console.error('[dp-capture-step-reward] dp-capture.js must load before this file');
    return;
  }

  /* shop.applyDiscount's outcome → which line to show. No code at all → 'none'. */
  function outcomeFor(result, hasCode) {
    if (!hasCode) return 'none';
    return result && result.ok ? 'applied' : 'fallback';
  }

  function rewardStep(root, ctx) {
    var code = root.querySelector(CODE_SELECTOR);
    var cta = root.querySelector(CTA_SELECTOR);
    var outcomes = root.querySelectorAll('[' + OUTCOME_ATTRIBUTE + ']');
    var listeners = [];

    function on(target, type, handler) {
      target.addEventListener(type, handler);
      listeners.push([target, type, handler]);
    }

    function reveal(outcome) {
      Array.prototype.forEach.call(outcomes, function (node) {
        node.hidden = node.getAttribute(OUTCOME_ATTRIBUTE) !== outcome;
      });
    }

    function show(result) {
      var outcome = outcomeFor(result, true);
      reveal(outcome);
      var props = { ok: outcome === 'applied' };
      if (result && typeof result.applicable === 'boolean') props.applicable = result.applicable;
      ctx.track(ctx.events.CODE_APPLIED, props);
    }

    return {
      mount: function () {
        var discount = ctx.config.DISCOUNT_CODE;

        return new Promise(function (resolve) {
          on(cta, 'click', function () {
            resolve({});
          });

          if (!discount) {
            reveal(outcomeFor(null, false));
            return;
          }
          code.textContent = discount;
          Array.prototype.forEach.call(root.querySelectorAll(CODE_ONLY_SELECTOR), function (node) {
            node.hidden = false;
          });

          var request;
          try {
            request = Promise.resolve(ctx.adapters.shop.applyDiscount(discount));
          } catch (error) {
            request = Promise.reject(error);
          }
          // The adapter never rejects by contract. If it ever does, the visitor still
          // gets the code and the checkout line, never a blank step.
          request.then(show, function (error) {
            console.error('[dp-capture-step-reward]', error);
            show({ ok: false });
          });
        });
      },
      unmount: function () {
        listeners.forEach(function (entry) {
          entry[0].removeEventListener(entry[1], entry[2]);
        });
        listeners = [];
      },
    };
  }

  // The pure part, for tests/dp-capture/. The theme never calls it directly.
  rewardStep.core = { outcomeFor: outcomeFor };

  capture.registerStep('reward', rewardStep);
})();
